import { Creator } from "./factory.class";
export class ItemPrice {
    constructor(params) {
        this.id = params.id;
        this.slug = params.slug;
        this.code = params.code;
        this.group = params.group;
        this.name = params.name;
        this.number = params.number;
        this.quantity = params.quantity;
        this.product = params.product;
        this.bu = params.bu;
        this.roof = params.roof;
        this.encoded = params.encoded;
        this._unitOfferPrice = params.unitOfferPrice;
        this.muOfferPrice = params.muOfferPrice;
        this.totalValueOffer = params.totalValueOffer;
        this.unitCost = params.unitCost;
        this.muCost = params.muCost;
        this.totalCost = params.totalCost;
        this.margin = params.margin;
        this.gunComment = params.gunComment;
        this.gaComment = params.gaComment;
        this.sapCurrentPrice = params.sapCurrentPrice;
        this.sapPreviousPrice = params.sapPreviousPrice;
        this.sapIncreasePrice = params.sapIncreasePrice;
        this.priceSoldPreviousYear = params.priceSoldPreviousYear;
        this.discountCeilingPrice = params.discountCeilingPrice;
        this._bidPrice = params.bidPrice;
        this.discountBidPrice = params.discountBidPrice;
        this.toApprove = !!params.toApprove;
        this.approvalStatus = params.approvalStatus;
        this.approvalDate = params.approvalDate;
        this.gaUser = params.gaUser;
        this.gunUser = params.gunUser;
        this.isCompleted = !!params.isCompleted;
    }
    setValues() {
        this.unitCost = this.product ? this.product.cost : 0;
        this.muCost = this.product ? this.unitCost * this.product.quantity_by_um : 0;
        this.totalCost = this.unitCost * this.quantity;
        this.calcMargin();
    }
    calcMargin() {
        this.margin = this.totalValueOffer > 0 ? ((this.totalValueOffer - this.totalCost) / this.totalValueOffer) * 100 : 0;
    }
    get muOfferPrice() {
        return Number(this._muOfferPrice.toFixed(2));
    }
    get unitOfferPrice() {
        return Number(this._unitOfferPrice.toFixed(2));
    }
    set muOfferPrice(value) {
        const tmp = Number(value);
        if (!isNaN(tmp)) {
            this._muOfferPrice = tmp;
        }
        else {
            this._muOfferPrice = 0;
        }
        this._unitOfferPrice = this.product ? (this._muOfferPrice / this.product.quantity_by_um) : 0;
    }
    set unitOfferPrice(value) {
        var _a, _b, _c, _d;
        const tmp = Number(value);
        if (!isNaN(tmp)) {
            this._unitOfferPrice = tmp;
        }
        else {
            this._unitOfferPrice = 0;
        }
        this._muOfferPrice = this.product ? (this._unitOfferPrice * this.product.quantity_by_um) : 0;
        if (this.product) {
            this.increasePriceSold = ((_b = (_a = this.product) === null || _a === void 0 ? void 0 : _a.sap) === null || _b === void 0 ? void 0 : _b.priceSold) > 0 ? (this._muOfferPrice - ((_c = this.product.sap) === null || _c === void 0 ? void 0 : _c.priceSold)) / ((_d = this.product.sap) === null || _d === void 0 ? void 0 : _d.priceSold) : 1;
        }
        this.totalValueOffer = this._unitOfferPrice * this.quantity;
        if (this.roof && this.roof > 0) {
            this.discountCeilingPrice = (this._muOfferPrice - this.roof) / this._muOfferPrice;
            this.calcDiscount();
        }
        this.calcMargin();
    }
    calcDiscount() {
        if (this._bidPrice && this._bidPrice > 0) {
            this.discountBidPrice = (this.muOfferPrice - this._bidPrice) / this.muOfferPrice;
        }
    }
    get bidPrice() {
        return this._bidPrice;
    }
    set bidPrice(value) {
        const tmp = Number(value);
        if (!isNaN(tmp)) {
            this._bidPrice = tmp;
        }
        else {
            this._bidPrice = 0;
        }
        this.calcDiscount();
    }
    get errorMessageGUNPending() {
        var _a;
        const priceError = this._muOfferPrice < ((_a = this.product) === null || _a === void 0 ? void 0 : _a.min_price);
        const costError = this._muOfferPrice < this.unitCost;
        if (priceError && costError) {
            return 'El precio y el costo aprobado por la empresa se encuentra por debajo del mínimo. El precio se encuentra en revisión por el gerente de división y el gerente General.';
        }
        else if (costError) {
            return 'El costo aprobado por la empresa se encuentra por debajo del mínimo. El precio se encuentra en revisión por el gerente de división y el gerente general.';
        }
        else if (priceError) {
            return 'El precio aprobado por la empresa se encuentra por debajo del mínimo. El precio se encuentra en revisión por el gerente de división.';
        }
        return '';
    }
    get errorMessageGUN() {
        var _a;
        const priceError = this.muOfferPrice <= ((_a = this.product) === null || _a === void 0 ? void 0 : _a.min_price);
        const costError = this.muOfferPrice <= this.muCost;
        if (priceError && costError) {
            return 'El precio y el costo aprobado por la división se encuentra por debajo del mínimo. El precio será enviado en revisión por el gerente de división y el gerente General.';
        }
        else if (priceError) {
            return 'El precio aprobado por la división se encuentra por debajo del mínimo. El precio será enviado a revisión por el gerente de división.';
        }
        else if (costError) {
            return 'El precio aprobado por la división es igual o menor al costo. El precio será enviado a revisión por el gerente de división y el gerente general.';
        }
        return '';
    }
    get IncreasePriceSoldPreviousYear() {
        var _a, _b, _c, _d;
        if (((_b = (_a = this.product) === null || _a === void 0 ? void 0 : _a.sap) === null || _b === void 0 ? void 0 : _b.priceSold) == 0) {
            return 0;
        }
        return this.muOfferPrice / ((_d = (_c = this.product) === null || _c === void 0 ? void 0 : _c.sap) === null || _d === void 0 ? void 0 : _d.priceSold) - 1;
    }
    get hasNewAlert() {
        var _a, _b;
        const error = [];
        error.push(this.muOfferPrice <= ((_a = this.product) === null || _a === void 0 ? void 0 : _a.min_price));
        error.push(this.muOfferPrice <= this.muCost);
        const abcPrices = !!this.product.abc;
        if (abcPrices) {
            error.push(this.muOfferPrice < this.product.abc.A);
            // error.push(this.product.sap?.priceSold > 0 && this.increasePriceSold < this.product.abc.increase);
            error.push(((_b = this.product.sap) === null || _b === void 0 ? void 0 : _b.priceSold) > 0 && this.IncreasePriceSoldPreviousYear < (this.product.abc.increase - 1));
        }
        return error.some(e => !!e);
    }
    get alertMessages() {
        var _a, _b;
        const priceError = this.muOfferPrice <= ((_a = this.product) === null || _a === void 0 ? void 0 : _a.min_price);
        const costError = this.muOfferPrice <= this.muCost;
        const abcPrices = !!this.product.abc;
        const messages = [];
        if (priceError) {
            messages.push('<i class="far fa-exclamation-triangle"></i> El precio aprobado por la división se encuentra por debajo del mínimo. El precio será enviado a revisión por el gerente de división.');
        }
        if (costError) {
            messages.push('<i class="far fa-exclamation-triangle"></i> El precio aprobado por la división es igual o menor al costo. El precio será enviado a revisión por el gerente de división y el gerente general.');
        }
        if (abcPrices) {
            if (this.muOfferPrice < this.product.abc.A) {
                messages.push('<i class="far fa-exclamation-triangle"></i> El precio ofertado se encuentra por debajo del precio Lista A, requiere aprobación del Gerente de División.');
            }
            // if (this.product.sap?.priceSold > 0 && this.increasePriceSold < this.product.abc.increase) {
            //     messages.push('<i class="far fa-exclamation-triangle"></i> El precio ofertado está por debajo del incremento autorizado por el directorio, requiere aprobación del Gerente de División.');
            // }
            if (((_b = this.product.sap) === null || _b === void 0 ? void 0 : _b.priceSold) > 0 && this.IncreasePriceSoldPreviousYear < (this.product.abc.increase - 1)) {
                messages.push('<i class="far fa-exclamation-triangle"></i> Incremento por debajo del Directorio.');
            }
        }
        return messages.length > 0 ? messages.join('<br>') : '';
    }
    get showNewAlert() {
        var _a;
        return this.hasNewAlert && ((_a = this.approvalStatus) === null || _a === void 0 ? void 0 : _a.value) !== 'aprobado';
    }
    get alert() {
        var _a, _b;
        //return this.product ? this._unitOfferPrice <= this.product.min_price : false;
        return this.product ? this.muOfferPrice <= this.product.min_price || this.muOfferPrice < ((_b = (_a = this.product) === null || _a === void 0 ? void 0 : _a.abc) === null || _b === void 0 ? void 0 : _b.A) : false;
    }
    get priceError() {
        var _a;
        return this.muOfferPrice <= ((_a = this.product) === null || _a === void 0 ? void 0 : _a.min_price);
    }
    get costError() {
        return this.muOfferPrice <= this.muCost;
    }
    get abcPricesListA() {
        var _a, _b;
        return this.muOfferPrice < ((_b = (_a = this.product) === null || _a === void 0 ? void 0 : _a.abc) === null || _b === void 0 ? void 0 : _b.A);
    }
    get abcPricesIncrementoDirectorio() {
        var _a;
        if (this.product) {
            return ((_a = this.product.sap) === null || _a === void 0 ? void 0 : _a.priceSold) > 0 && this.IncreasePriceSoldPreviousYear < (this.product.abc.increase - 1);
        }
    }
    get unitOfferErrorMessage() {
        var _a, _b, _c;
        if (!!this._unitOfferPrice) {
            if (this.alert) {
                //const priceError = this._unitOfferPrice < this.product?.min_price;
                const priceError = this.muOfferPrice < ((_a = this.product) === null || _a === void 0 ? void 0 : _a.min_price);
                //const costError = this._unitOfferPrice < this.unitCost
                const costError = this.muOfferPrice < this.muCost;
                const priceListAError = this.muOfferPrice < ((_c = (_b = this.product) === null || _b === void 0 ? void 0 : _b.abc) === null || _c === void 0 ? void 0 : _c.A);
                if (costError) {
                    return 'Precio por debajo del costo';
                }
                else if (priceError) {
                    return 'Precio por debajo del mínimo';
                }
                else if (priceListAError) {
                    return 'Precio por debajo de la lista A';
                }
            }
        }
        return null;
    }
    get grossMargin() {
        return this.totalValueOffer - this.totalCost;
    }
    get pending() {
        return !this._unitOfferPrice || !this.bidPrice;
    }
    get canApprove() {
        var _a;
        return this.toApprove && ((_a = this.approvalStatus) === null || _a === void 0 ? void 0 : _a.value) == 'pendiente';
    }
    get isDisabled() {
        return this.toApprove || this.isCompleted;
    }
    get showAlert() {
        var _a;
        return this.alert && ((_a = this.approvalStatus) === null || _a === void 0 ? void 0 : _a.value) !== 'aprobado';
    }
    get full() {
        return this.valid && (!this.alert || this.approvalStatus.value === 'aprobado');
    }
    get valid() {
        //return !!this.bidPrice && !!this._unitOfferPrice;
        return !!this._unitOfferPrice;
    }
    get enabled() {
        return !this.isCompleted && !this.toApprove && this.valid;
    }
    toUpdate() {
        return {
            id: this.id,
            muOfferPrice: this.muOfferPrice,
            unitOfferPrice: this.unitOfferPrice,
            bidPrice: this.bidPrice,
            totalValueOffer: this.totalValueOffer,
            muCost: this.muCost,
            totalCost: this.totalCost,
            margin: this.margin,
            toReview: this.hasNewAlert,
            comment: this.hasNewAlert ? this.gunComment : null,
            abc: this.product.abc,
            increase: this.increasePriceSold,
            sap: {
                current: this.sapCurrentPrice,
                increase: this.sapIncreasePrice,
                previous: this.sapPreviousPrice,
                priceSold: this.priceSoldPreviousYear
            }
        };
    }
}
export class CreatorItemPrice extends Creator {
    create(params) {
        const item = new ItemPrice(params);
        item.setValues();
        return item;
    }
}
